import { logError } from "~/shared/services/error-reporting";
import { useApi } from "./use-api";

export const useManuscriptActions = () => {
  const api = useApi();

  const createProductFromManuscript = async (file: File) => {
    const data = {
      manuscript: file,
    };

    try {
      const result = await api.products.createProductFromManuscript(data);
      return result;
    } catch (error) {
      logError(error);
      throw error;
    }
  };

  const generateProductManuscriptAnalysis = async (productId: string) => {
    try {
      const result =
        await api.products.generateProductManuscriptAnalysis(productId);
      return result;
    } catch (error) {
      logError(error);
      throw error;
    }
  };

  const deleteProductWithManuscript = async (productId: string) => {
    try {
      const result = await api.products.deleteProduct(productId);
      return result;
    } catch (error) {
      logError(error);
      throw error;
    }
  };

  return {
    createProductFromManuscript,
    generateProductManuscriptAnalysis,
    deleteProductWithManuscript,
  };
};
